type DeviceType = "mobile" | "desktop";
export const responsiveCalc = (px: string, device: DeviceType = "desktop") => {
  const base = device === "mobile" ? 390 : 1280;
  const newValue = (parseInt(px.replace(/^px+/i, "")) / base) * 100;
  return `min(${newValue}vw, ${px})`;
};
